var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.187 25.527a.245.245 0 11-.003-.49H21V7h-.49v17.564h-8.392a.703.703 0 00-.688.698v.017a.681.681 0 00.638.722.693.693 0 00.09 0H21v-.473zM12.16 6A1.16 1.16 0 0011 7.16v17.73a1.18 1.18 0 011.118-.816H20V6zm1.488 4.753l2.345-1.614v-.032h-2.345v-.671h3.706v.65l-2.34 1.615v.031h2.34v.667h-3.706zm0 1.423h3.706v2.222h-.651v-1.482h-.853v1.217h-.645v-1.217h-.906v1.482h-.65zm0 5.634l2.817-.635v-.054l-2.816-.64v-.874l3.598-.735h.106v.741l-2.593.434v.063l2.593.577v.953l-2.593.583v.058l2.593.433v.705h-.106l-3.599-.73zm3.6 3.984h-.62l-.053-.085a1.203 1.203 0 00.217-.705c0-.327-.143-.518-.386-.518-.228 0-.334.137-.508.635a1.15 1.15 0 01-1.164.905 1.167 1.167 0 01-1.17-1.286 1.67 1.67 0 01.286-1.027h.64l.053.09a1.287 1.287 0 00-.333.878c0 .371.18.593.476.593.286 0 .429-.143.593-.598.233-.683.54-.942 1.085-.942a1.096 1.096 0 011.075 1.233 1.63 1.63 0 01-.192.827z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--newspaper-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'NewspaperCircleIcon';
export default Icon;